import React, { useEffect, useReducer } from 'react';

import Personal from './user-details/Personal';
import Contract from './user-details/Contract';
import Absence from './user-details/Absence';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Tabs, Tab } from 'react-bootstrap';
import DirectoryService from './DirectoryService';
import FormModal from '../common/FormModal';
import ProfileBanner from './Banner.js';
import PasswordSettingsForm from './user-details/PasswordSettings';
import EquipmentList from '../equipments/EquipmentList';
import emptyContract from './user-details/emptyContract';
import { empty } from 'is_js';
import FollowersList from './FollowersList';
import { useState } from 'react';

const UserDetails = () => {
  const [key, setKey] = useState('personal');
  const [profile, setProfile] = useState();
  const [contract, setContract] = useState();
  const [showError, setShowError] = useState(false);
  const [showTabs, setShowTabs] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [renderPage, setRenderPage] = useState(false);
  const { identifier } = useParams();
  const retrieveEmptyProfile = () => {
    return {
      identifier: null,
      avatar: null,
      firstName: null,
      title: null,
      lastName: null,
      roles: [],
      contract: {
        identifier: null,
        lengthOfService: null,
        startDate: null,
        contService: null,
        benefitsStart: null,
        jobType: null,
        country: null,
        location: null,
        department: null,
        myLineManager: null,
        rightToWork: null,
        rightToWorkExpires: null,
        hoursPerWeek: null,
        daysPerWeek: null,
        fte: null,
        workPattern: null,
        holidayEntitlement: 0,
        holidayBroughtForward: 0,
        holidayTotalThisYear: 0,
        noticePeriod: null
      }
    };
  };
  const updateProfile = (updatedProfile, userAvatar) => {
    DirectoryService.saveProfile(updatedProfile, userAvatar)
      .then(response => {
        console.log(response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };
  const updateContract =  (profileIdentifier, updatedContract) => {
    console.log('Updated Contract: ', updatedContract);
    console.log('Profile Identifier: ', profileIdentifier);
    
    DirectoryService.saveContract(profileIdentifier, updatedContract).then(
      response => {
        console.log(response);
      }
    );
  };
  useEffect(() => {
    const loggedProfile = DirectoryService.retrieveLoggedProfile();
    if (identifier !== undefined) {
      DirectoryService.retrieveProfile(identifier)
        .then(profile => {
          console.log('Profile.state: ', profile);
          if (profile.contract === null) {
            const empty = {
              emptyContract
            };
          }
          const updatedContract =
            profile.contract === null ? empty : profile.contract;
          const updatedProfile = { ...profile, contract: updatedContract };
          console.log('Updated Profile: ', updatedProfile);
          const tabs =
            loggedProfile.identifier === identifier ||
            DirectoryService.isLoggedByHRAdmin();
          setProfile(updatedProfile);
          setContract(updatedContract);
          setShowTabs(tabs);
          setRenderPage(true);
        })
        .catch(error => {
          console.log(error);
          //window.location.href = '/error/404';
        });
    } else {
      const emptyProfile = retrieveEmptyProfile();
      setProfile(emptyProfile);
      setContract(emptyProfile.contract);
      setShowTabs(true);
      setRenderPage(true);
    }
  }, [identifier]);

  return (
    <>
      {modalShow && (
        <FormModal
          message={'Employee has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
          redirectUrl="/social/directory/user-list"
        />
      )}
      {renderPage && showTabs && (
        <>
          <ProfileBanner profile={profile} />
          <Tabs defaultActiveKey={key} id="controlled-tab-example">
            <Tab
              eventKey="personal"
              title="Personal"
              className="border-bottom border-x p-3"
            >
              <Personal
                profile={profile}
                updateProfile={updateProfile}
              ></Personal>
            </Tab>
            <Tab
              eventKey="contract"
              title="Contract"
              className="border-bottom border-x p-3"
            >
              <Contract
                contract={contract}
                profile={profile}
                updateContract={updateContract}
              ></Contract>
            </Tab>
            <Tab
              eventKey="absence"
              title="Absence"
              className="border-bottom border-x p-3"
            >
              <Absence profile={profile}></Absence>
            </Tab>
            <Tab
              eventKey="settings"
              title="Settings"
              className="border-bottom border-x p-3"
            >
              <PasswordSettingsForm profile={profile} />
            </Tab>
            <Tab
              tabClassName="d-none"
              eventKey="benefits"
              title="Benefits"
              className="border-bottom border-x p-3"
            ></Tab>
            <Tab
              eventKey="equipment"
              title="Equipment"
              className="border-bottom border-x p-3"
            >
              <EquipmentList profile={profile}></EquipmentList>
            </Tab>
            <Tab
              tabClassName="d-none"
              eventKey="training"
              title="Training"
              className="border-bottom border-x p-3"
            ></Tab>
          </Tabs>
        </>
      )}
      {renderPage && !showTabs && (
        <>
          <ProfileBanner profile={profile} />
          <FollowersList />
        </>
      )}
    </>
  );
};

UserDetails.propTypes = {
  params: PropTypes.shape({
    identifier: PropTypes.any
  })
};

export default UserDetails;
